'use client';

import { Suspense } from 'react';

import { useHydration } from '@/server/hooks/useHydration';
import { formatEventInviteDateV2 } from '@/ui/components/Event/utils/formatMessageEventCardDate';

import css from './v2.module.scss';

export const LocalDateTime = ({ startTime, endTime }: { startTime: string; endTime: string }) => {
  const { suspenseKey } = useHydration();
  const { monthDay, time } = formatEventInviteDateV2(startTime, endTime);
  return (
    <Suspense key={suspenseKey} fallback={<span>Loading...</span>}>
      <div className={css.datetime}>
        <div className={css.day}>{monthDay}</div>
        <div className={css.time}>{time}</div>
      </div>
    </Suspense>
  );
};
